import { css } from "@emotion/react";
export const verticalAlignedFlexbox = css`
  display: flex;
  align-items: center;
`;
export const flexBetween = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const fadeIn = css`
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease;
  animation-duration: 0.55s;
`;
